const base = "/api/v1";

module.exports = base;
